export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-delicious-4249468bf3e7a9e8b702e5b914146dcb.svg";